const STORAGE_KEY = 'cp_routing_key_v1';

export function generateRoutingKey() {
  return crypto.randomUUID();
}

export function getRoutingKey() {
  if (typeof window !== 'undefined' && window.CP_ROUTING_KEY) {
    sessionStorage.setItem(STORAGE_KEY, window.CP_ROUTING_KEY);
    delete window.CP_ROUTING_KEY;
  }

  let key = sessionStorage.getItem(STORAGE_KEY);
  if (!key) {
    key = generateRoutingKey();
    sessionStorage.setItem(STORAGE_KEY, key);
  }
  return key;
}

export function clearRoutingKey() {
  sessionStorage.removeItem(STORAGE_KEY);
}
